import Table from '@ui-components-3/ui/lib/components/Table'
import Menu from '@ui-components-3/ui/lib/components/Menu'
import EllipsisVerticalIcon from '@ui-components-3/icons/lib/solid/EllipsisVertical'
import { ComponentProps } from 'react'
import CommonTable from '../CommonTable/CommonTable'

export const TableFooter = () => (
  <Table.Footer className="!pt-s">
    <div className="gap-xs ml-auto flex flex-wrap justify-end">
      <Table.RowsPerPage />
      <Table.Pagination />
    </div>
  </Table.Footer>
)

export const TableEmptyState = () => <Table.EmptyBody className="!min-h-[150px]" />

type TableRowActionsMenuItem = {
  label: string
  className?: string
  onClick: (rowData: any) => void
}

type TableRowActionsMenuProps = Pick<ComponentProps<typeof CommonTable>, 'aria-label'> & {
  actions: TableRowActionsMenuItem[]
  rowData: any
}

export const TableRowActionsMenu = ({ actions, rowData, ...props }: TableRowActionsMenuProps) => {
  const stopPointerEventPropagation = (e: Pick<PointerEvent, 'stopPropagation'>) => {
    e?.stopPropagation()
  }

  return (
    <Menu
      {...props}
      className="btn btn-primary-borderless !bg-transparent"
      items={actions?.map(({ label, className, onClick }, i) => (
        <button type="button" className={className} onClick={() => onClick(rowData)} key={`${label}_${i}`}>
          {label}
        </button>
      ))}
      itemClassName="min-w-[150px]"
      portal
      onPointerDown={stopPointerEventPropagation}
      onClick={stopPointerEventPropagation}
      onMouseDown={stopPointerEventPropagation}
    >
      <EllipsisVerticalIcon aria-hidden="true" className="w-5 h-5" />
    </Menu>
  )
}
